module.exports = __webpack_public_path__ + "img/SETTINGS.c4e1ea33.svg";